import React, { useEffect, useState } from 'react'
import styles from './teams.module.scss';
import correcticon1 from '../../styles/images/teamscorrect1.svg';
import correcticon2 from '../../styles/images/teamscorrect2.svg';
import wrong from '../../styles/images/teamswrong.svg';
import { ApiServices } from '../../app/base/service/apiService';
import { util } from '../../app/base/utils';
import { useSelector, useDispatch } from 'react-redux';
import { setGraphToken, setTeamsToken, setMsDomain, setSbcDetails } from '../../store/profile';
import { API_ROUTE_CONTROLLER } from '../../app/base/routes';
import axios from 'axios';
import { useNavigate  } from 'react-router-dom';
import {config} from '../../app/base/constant'
// import {changePage} from '../../app/base/utils';

const Initialsetup = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const login = useSelector((state: any) => state.login.login);
  const sbc_fqdn = login?.domain_name?.replace('callth.','');
  const directRoutingToken = useSelector((state: any) => state.profile);
  const [storeValue, setStoreValue] = useState( directRoutingToken.graphToken ? 'success' : "")
  const [token, setToken] = useState('');

  const redirectMicrosoftApi = async () => {
    const url = `${config().CCAAS_CONNECTOR_URL}/directrouting/graph/admin/login`;
    // window.open(url, '_');
    window.location.replace(url);
  }



  const StoreTokenApi = async () => {
    const url = API_ROUTE_CONTROLLER.store_Token;
    const body = {
      domainId: login?.domain_id,
      roleId: 3,
      connectorName: "directrouting",
      token: token ? token : "" 
    }
    return await ApiServices.post(body, url).then(async (value: any) => {
      console.log("tokenvalue", value.data.results.token);
    });
  }


  const NextPage = async () => {
    // StoreTokenApi()
    navigate("/directrouting/pbx")
  }

  const getTeamsSbcFqdnPort = async() => {
    const url = API_ROUTE_CONTROLLER.teams_fqdn_port;
        await axios.get(url).then((resp)=> {
          console.log("resp------------fqdn",resp.data)
        if(resp.data.statusCode === 200) {
          let alreadyAssigned = resp.data.result.find((data:any)=> data.company_id === "")
            dispatch(setSbcDetails(resp.data.result))
        }
        }).catch((err)=> {
          console.log("err----",err);
        })
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    let code: any = params.get("code");
    let error: any = params.get("error");
    // getTeamsSbcFqdnPort();
    if (code != null) {
      setStoreValue("success");
      setToken(code);
      // let url = API_ROUTE_CONTROLLER.refresh_token + "/" + login?.domain_id;
      // let headers = {
      //   Authorization: code
      // }
      // axios.get(url, { headers }).then((token) => {
      //   console.log("data-------", token);
      // }).catch((err) => {
      //   console.log("err", err);
      // })  
      localStorage.setItem('directrouting1',code);
      dispatch(setGraphToken(code));
    }
    else if (error != null) {
      setStoreValue("failure");
    }
  }, [])


  const changePage =(key :number)=> {
   
    switch(key) {
      case 1 : 
       navigate('/directrouting')
      break;

      case 3 : 
       navigate('/directrouting/pbx')
      break;
      
      case 4 : 
       navigate('/directrouting/teams')
      break;

      case 5 : {
        if(directRoutingToken.teamsToken){
          navigate('/userlist')
        }
      }
      break;
      case 6 : 
        navigate('/directrouting/account')
      break;

      default : 
       navigate('/directrouting')
      break;
    }
  
  }



  return (
    <>
      <div className="breadcrumbarea">
        <h4>Teams Integration</h4>
        <p>
          Direct Routing allows connecting the Teams Phone calling system
          through Worktual that enabling seamless voice communication
          capabilities.
        </p>
      </div>
      <div className={styles.teamstab}>
          <ul>
          <li onClick ={() => {changePage(1)}}>
              <span>1</span>
              <h5>Domain verification</h5>
            </li>
            <li className={ styles.activetab} >
              <span>2</span>
              <h5>Admin Setup</h5>
            </li>
            <li onClick={()=>{changePage(3)}}>
              <span>3</span>
              <h5>Servicespbx</h5>
            </li>
            <li onClick={()=>{changePage(4)}}>
              <span>4</span>
              <h5>Servicesteams</h5>
            </li>
            <li onClick={()=>{changePage(5)}}>
              <span>5</span>
              <h5>User</h5>
            </li>
            {/* <li onClick={()=>{changePage(6)}}>
              <span>6</span>
              <h5>Account</h5>
            </li> */}
          </ul>
      </div>
      <div className={styles.teamsmaincontainer}>
        <div className={styles.frstsecadminsetup}>
          <p>
            Before you begin the admin setup, you need to validate the
            following:
          </p>
        </div>
        <div className={styles.frstsecadminsetup}>
          <p>PBX Setup</p>
        </div>
        <div className={styles.firstcol}>
              <p className={styles.sbcserv}>
                SBC assigned to this service: {sbc_fqdn}{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  onClick = {()=> {navigator.clipboard.writeText(sbc_fqdn)}}
                >
                  <path
                    d="M16.6688 1.47358C15.5306 0.393484 13.9588 0.210885 12.431 0.174785C11.1869 0.142585 10.306 0.142585 9.06576 0.174785C7.53696 0.210885 5.96516 0.392585 4.82696 1.47358C4.35576 1.92038 4.06806 2.46188 3.88636 3.03068C2.84426 3.22798 2.01966 3.60708 1.39086 4.20398C0.140358 5.39048 0.104758 7.21768 0.0788581 8.55258L0.0759583 11.9647L0.0788581 12.1122C0.104758 13.4462 0.140358 15.2733 1.39086 16.4696C2.57836 17.5966 4.22336 17.787 5.82246 17.8251C6.47626 17.8417 7.03436 17.8495 7.59196 17.8495C8.14956 17.8495 8.70816 17.8417 9.36006 17.8251C10.9607 17.787 12.6057 17.5966 13.7932 16.4696C14.4992 15.8002 14.8039 14.9315 14.9479 14.1517C15.5776 13.9603 16.1666 13.6651 16.6687 13.1883C17.865 12.0545 17.9006 10.3299 17.9241 9.17368V5.47348C17.9007 4.33288 17.8651 2.60838 16.6688 1.47358ZM16.4117 5.06298C15.6552 5.05448 15.109 5.02249 14.6785 4.89839C13.4583 4.56149 12.5374 3.43838 12.4388 2.16208C12.4254 2.00048 12.4331 1.83858 12.4355 1.67698C13.8343 1.71238 14.9169 1.87818 15.6365 2.56148C16.2373 3.13178 16.3716 4.05828 16.4117 5.06298ZM12.7611 15.3818C11.9872 16.1162 10.828 16.29 9.32356 16.3252C8.04426 16.3584 7.14236 16.3584 5.85916 16.3252C4.35626 16.29 3.19706 16.1152 2.42556 15.3838C1.62766 14.6211 1.60186 13.2725 1.57886 12.084L1.57596 8.73148L1.57886 8.58208C1.60176 7.39358 1.62766 6.04689 2.42306 5.29209C2.73206 4.99908 3.12196 4.78868 3.60466 4.63848C3.58116 4.98788 3.57406 5.32549 3.56806 5.63479L3.56516 8.87988L3.56806 9.02048C3.59246 10.2949 3.62616 12.041 4.82636 13.1885C5.96456 14.2686 7.53636 14.4512 9.06416 14.4873C9.68626 14.5029 10.217 14.5107 10.7478 14.5107C11.2781 14.5107 11.8093 14.5029 12.4294 14.4873C12.7288 14.4802 13.0294 14.4644 13.3286 14.4404C13.1955 14.8342 13.0118 15.144 12.7611 15.3818ZM15.6366 12.1006C14.9091 12.791 13.8143 12.9541 12.3929 12.9873C11.1761 13.0176 10.3197 13.0176 9.10086 12.9873C7.68096 12.9541 6.58626 12.791 5.86116 12.1025C5.11406 11.3877 5.08966 10.1152 5.06766 8.99208L5.06526 5.80658L5.06766 5.66298C5.08966 4.54088 5.11406 3.26848 5.85966 2.56138C6.58626 1.87098 7.68096 1.70788 9.10236 1.67468C9.71076 1.65908 10.2289 1.65128 10.7479 1.65128C10.8002 1.65128 10.8547 1.65228 10.9071 1.65248C10.9044 1.86388 10.8965 2.07628 10.9139 2.28408C11.0628 4.21768 12.4124 5.86028 14.263 6.37098C14.8597 6.54308 15.5243 6.58238 16.4241 6.59168V9.15808C16.4002 10.3378 16.3217 11.4512 15.6366 12.1006Z"
                    fill="#575CFF"
                  />
                </svg>
              </p>
            </div>
        <div className={styles.chcklstsectionn}>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p>A login to your Office 365 account with Global admin rights</p>
          </div>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p> Microsoft Phone system license add-ons (or E5 licenses with calling plan) for the end users of the service</p>
          </div>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p>One or Two unassigned Office 365 user licenses such as Business basic/Premium or E1/E3/E5, for a few hours during the initial setup</p>
          </div>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p>Access to your PBX or Trunk portal to create/manage SIP credentials</p>
          </div>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p>At least one Worktual Voice for Teams license</p>
          </div>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p>Microsoft tenant supports Direct Routing configuration</p>
          </div>
          <div className={styles.setupfrstrow}>
            <img src={storeValue === 'success' ? correcticon2 : storeValue === 'failure' ? wrong : correcticon1} alt="icon" />
            <p>Using a modern compatible web browser</p>
          </div>

        </div>
      </div>
      <div className={styles.btnflexx}>
        <button className='cancelbtn' onClick ={() => navigate('/directrouting')}>Cancel</button>
        {storeValue == 'success' ? <button onClick={() => NextPage()}>Next</button> :
          <button onClick={() => redirectMicrosoftApi()}>Validate</button>
        }


      </div>
    </>
  )
}

export default Initialsetup
